import { Badge } from '@ironscales/design-system'

export default Badge

export const SIZES = Badge.SIZES
export const SHAPES = Badge.SHAPES
export const VARIANTS = Badge.VARIANTS
